import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface ErrorFallbackProps {
    error: Error;
    resetErrorBoundary?: () => void;
}

export default function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-4">
            <div className="panel w-full max-w-lg text-center">
                <div className="mb-6">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-24 w-24 mx-auto text-danger"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>
                <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-white">
                    {t('something_went_wrong') || "Something went wrong"}
                </h2>
                <p className="text-gray-600 dark:text-gray-400 mb-6">
                    {error.message || "An unexpected error occurred. Please try again later."}
                </p>
                <div className="flex justify-center gap-4">
                    {resetErrorBoundary && (
                        <button
                            onClick={resetErrorBoundary}
                            className="btn btn-primary"
                        >
                            {t('try_again') || "Try Again"}
                        </button>
                    )}
                    <Link to="/" className="btn btn-outline-primary">
                        {t('go_home') || "Go Home"}
                    </Link>
                </div>
            </div>
        </div>
    );
}
